import React, { useState } from "react";
import { TextField, Box, Grid } from "@mui/material";
import { CustomLabel } from "./CustomTypography";
import SearchIcon from "../../assets/Icon/SearchIcon.png";
import RoundSearchIcon from "../../assets/Icon/RoundSearchIcon.png";

const SearchComponent = ({ onSearch, title, t, roundIcon, placeholder }) => {
  const [searchQuery, setSearchQuery] = useState("");

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
    onSearch(event.target.value);
  };
  const handleSearchIconClick = () => {
    onSearch(searchQuery);
  };
  return (
    <Box sx={{ padding: roundIcon ? "0px" : "16px" }}>
      <CustomLabel>{title}</CustomLabel>
      <Grid container sx={{ marginTop: "15px" }} spacing={2}>
        <Grid item xs={roundIcon ? 11 : 10}>
          <TextField
            id="search"
            label={t("Search Here")}
            variant="outlined"
            sx={{ marginTop: "1px" }}
            fullWidth
            value={searchQuery}
            onChange={handleSearchChange}
            placeholder={placeholder || t("Search by FPO Name")}
            size="small"
            InputProps={{ sx: { borderRadius: roundIcon ? 6 : 0 } }}
          />
        </Grid>
        <Grid item xs={roundIcon ? 1 : 2}>
          <Box onClick={handleSearchIconClick} sx={{ padding: "0px" }}>
            <img
              src={roundIcon ? RoundSearchIcon : SearchIcon}
              style={{ width: "53px", height: "52px" }}
              alt="search"
            />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default SearchComponent;
